import {SupportPlanTask} from '../../model/support/task/support-plan-task';
import {SupportPlanTaskType} from '../../model/support/task/support-plan-task-type.enum';
import {SupportPlanTaskUserModel} from '../../model/support/task/support-plan-task-user.model';
import {Searchable} from '../../state/searchable-state';
import axios from '../axios';

export namespace SupportPlanTaskController {
  export type CreateSupportPlanTaskReq = {
    ticketId: string | null
    ticketName: string | null
    taskType: SupportPlanTaskType
    title: string
    description: string
    startDate: string | null
    endDate: string | null
    startTime: string | null
    endTime: string | null
    plannedHours: number
    meetingLink: string | null
    users: SupportPlanTaskUserModel[]
  }

  export const createSupportPlanTask = async (organizationId: string, supportPlanId: string, req: CreateSupportPlanTaskReq) =>
    (await axios.post(`/internal/support/organizations/${organizationId}/plan/${supportPlanId}/tasks`, req))

  export type UpdateSupportPlanTaskReq = {
    ticketId: string | null
    ticketName: string | null
    taskType: SupportPlanTaskType
    title: string
    description: string
    summary: string
    startDate: string | null
    endDate: string | null
    startTime: string | null
    endTime: string | null
    plannedHours: number
    meetingLink: string | null
  }

  export const updateSupportPlanTask = async (organizationId: string, supportPlanId: string, taskId: string, version: number, req: UpdateSupportPlanTaskReq) =>
    (await axios.put(`/internal/support/organizations/${organizationId}/plan/${supportPlanId}/tasks/${taskId}?version=${version}`, req))

  export const deleteSupportPlanTask = async (taskId: string, version: number) =>
    (await axios.delete(`/internal/support/organizations/plan/tasks/${taskId}?version=${version}`))


  export type SupportPlanTaskPaginated = {
    total: number
    available: any
    taskIds: string[]
    items: SupportPlanTask[]
  }

  export const fetchCustomerSupportPlanTasks = async (organizationId: string, supportPlanId: string, searchable: Searchable) =>
    (await axios.put<SupportPlanTaskPaginated>(`/internal/support/organizations/${organizationId}/plan/${supportPlanId}/tasks`, searchable)).data
}